/**
 *
 * @param {*} obj object to clean
 * @returns object without null / undefined / ""
 */
export default function clearDuplicatedItemFromArrOfObject(arr, key) {
  const newArr = [...arr];
  const obj = {};
  newArr.forEach((item) => {
    obj[item[key]] = item;
  });
  return Object.values(obj);
}
